@if (linkSelection.length > 0) {
  <div class="row-center">
    <mat-form-field style="width:230px;">
      <mat-label>Select dashboard</mat-label>
      <mat-select (selectionChange)="switchDashboard($event.value)">
        @for (obj of linkSelection; track obj) {
          <mat-option [value]="obj.link">
            {{ obj.description }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
}

<div class="iframe-container">
  @if (iframeLink) {
    <iframe [src]="iframeLink" allowfullscreen frameborder="0" frameborder="0" height="100%"
      id="iframe" width="100%">
    </iframe>
  } @else {
    <div class="row-center">
      <h3>Your user is not allowed to see any dashboard.</h3>
    </div>
  }
</div>

